import { render, staticRenderFns } from "./LinksTable.vue?vue&type=template&id=190b4cd6&scoped=true"
import script from "./LinksTable.vue?vue&type=script&lang=js"
export * from "./LinksTable.vue?vue&type=script&lang=js"
import style0 from "./LinksTable.vue?vue&type=style&index=0&id=190b4cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190b4cd6",
  null
  
)

export default component.exports